var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPortUsage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 310,
    height: 50,
    viewBox: "0 0 310 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b3cea6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a6c38d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_456",
    "data-name": "Group 456",
    transform: "translate(-250 -976)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1902",
    "data-name": "Rectangle 1902",
    transform: "translate(363 976)",
    stroke: "#fff",
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51,
    height: 50,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 50,
    height: 49,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1898",
    "data-name": "Rectangle 1898",
    transform: "translate(314 976)",
    stroke: "#fff",
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 50,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 32,
    height: 49,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1900",
    "data-name": "Rectangle 1900",
    transform: "translate(421 976)",
    stroke: "#fff",
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 50,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 26,
    height: 49,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1904",
    "data-name": "Rectangle 1904",
    transform: "translate(491 976)",
    stroke: "#fff",
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 50,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 26,
    height: 49,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1896",
    "data-name": "Rectangle 1896",
    transform: "translate(288 976)",
    stroke: "#fff",
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 50,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 26,
    height: 49,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1901",
    "data-name": "Rectangle 1901",
    transform: "translate(413 976)",
    stroke: "#fff",
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 50,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 8,
    height: 49,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1905",
    "data-name": "Rectangle 1905",
    transform: "translate(471 976)",
    stroke: "#fff",
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 50,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 20,
    height: 49,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1897",
    "data-name": "Rectangle 1897",
    transform: "translate(346 976)",
    stroke: "#fff",
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 50,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 17,
    height: 49,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1899",
    "data-name": "Rectangle 1899",
    transform: "translate(447 976)",
    stroke: "#fff",
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 50,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 24,
    height: 49,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1906",
    "data-name": "Rectangle 1906",
    transform: "translate(535 976)",
    stroke: "#fff",
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0H20a5,5,0,0,1,5,5V45a5,5,0,0,1-5,5H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,.5H20A4.5,4.5,0,0,1,24.5,5V45A4.5,4.5,0,0,1,20,49.5H1A.5.5,0,0,1,.5,49V1A.5.5,0,0,1,1,.5Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1903",
    "data-name": "Rectangle 1903",
    transform: "translate(517 976)",
    stroke: "#fff",
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 50,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 18,
    height: 49,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1895",
    "data-name": "Rectangle 1895",
    transform: "translate(250 976)",
    stroke: "#65a844",
    strokeWidth: 2,
    fill: "url(#linear-gradient)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5,0H39a0,0,0,0,1,0,0V50a0,0,0,0,1,0,0H5a5,5,0,0,1-5-5V5A5,5,0,0,1,5,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,1H37a1,1,0,0,1,1,1V48a1,1,0,0,1-1,1H5a4,4,0,0,1-4-4V5A4,4,0,0,1,5,1Z",
    fill: "none"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortUsage);
export default __webpack_public_path__ + "static/media/port_usage.2b55eec850be5c8c4001938d263a9b05.svg";
export { ForwardRef as ReactComponent };